import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Table } from '@teamsnap/teamsnap-ui';
import { useQuery } from '@apollo/client';
import { ShowProgramSeasonSummaries, GqlSeasonSummary } from '../../core/gql/queries/show-season-summary';
import * as GqlPrograms from '../../core/gql/queries/programs';
import { GqlProgram } from '../../core/gql/fragments/program';
import * as _ from 'lodash';

const tableHeaders = [
  {
    name: 'col1',
    label: 'Program/Season',
    isSortable: false,
    align: 'left',
    mods: 'u-size2of11',
  },
  {
    name: 'col2',
    label: 'Teams',
    isSortable: false,
    align: 'right',
    mods: 'u-size1of11',
  },
  {
    name: 'col3',
    label: 'Players',
    isSortable: false,
    align: 'right',
    mods: 'u-size1of11',
  },
  {
    name: 'col4',
    label: 'Commissioners',
    isSortable: false,
    align: 'right',
    mods: 'u-size2of11',
  },
  {
    name: 'col5',
    label: 'Coaches/Managers',
    isSortable: false,
    align: 'right',
    mods: 'u-size2of11',
  },
];

const ProgramReport: React.FunctionComponent<RouteComponentProps<any>> = (props) => {
  const { orgId } = props.match.params;
  const orgIdAsInt = parseInt(orgId);

  const showSeasonSummaryResponse = useQuery(ShowProgramSeasonSummaries, {
    variables: { organizationId: orgIdAsInt, isArchived: false },
    fetchPolicy: 'cache-and-network',
  });

  const queryPrograms = useQuery(GqlPrograms.QUERY, {
    variables: { organizationId: +orgId },
    fetchPolicy: 'cache-first',
  });
  const programs = queryPrograms.data?.programs || [];
  const programSeasonSummaries = showSeasonSummaryResponse.data?.programSeasonSummaries || [];

  const createTableRowData = (
    programs: GqlProgram[],
    programSesonSummaries: GqlSeasonSummary[],
    organizationId: number
  ): Object[] =>
    _.flatMap(programs, (program, pidx) =>
      programSesonSummaries
        .filter((summary) => summary.programId == program.id)
        .map((season, sidx) => {
          const link = `/organizations/${organizationId}/programs/${program.id}`;
          return {
            id: parseInt(pidx + '' + sidx),
            col1: (
              <div>
                <div>
                  <Link to={link}>{program.name}</Link>
                </div>
                <div>
                  <small>{season.name}</small>
                </div>
              </div>
            ),
            col2: season.activeTeamCount || 0,
            col3: season.activeAssignedPlayerCount || 0,
            col4: season.activeCommissionerCount || 0,
            col5: season.activeManagerCount || 0,
          };
        })
    );

  const isLoading =
    (showSeasonSummaryResponse.loading || queryPrograms.loading) &&
    (programs.length === 0 || programSeasonSummaries.length === 0);

  return (
    <div id="program" className="container">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1>Programs Report</h1>
          </div>
        </div>

        <div className="page-content-body">
          <h3>Current Active Seasons</h3>
          <Table
            isLoading={isLoading}
            columns={tableHeaders}
            rows={createTableRowData(programs, programSeasonSummaries, orgIdAsInt)}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgramReport;
